<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <a class="back-btn" :href="langingURL"></a>
    <a
      class="kefu-btn"
      href="https://bjsqxwhyxgs.qiyukf.com/client?k=31376a2d5639328d871def1a93bb6ced&wp=1"
    ></a>
    <footer class="footer">SKF 斯凯孚 @2020</footer>
  </div>
</template>

<script>
import api from "@/components/axios";

export default {
  name: "App",
  created() {
    // const isLogin = this.$cookies.get("token");
    // const isGetUserInfo = this.$cookies.get("getUserInfo");
    // if (!isLogin && !isGetUserInfo) {
    //   this.toLogin();
    //   this.codeLogin();
    // }
  },
  methods: {
    // 获取地址栏 accessToken 登录
    toLogin() {
      const accessToken = this.getUrlKey("accessToken");
      if (accessToken) {
        api.get("/sso/user_info/access_token?accessToken=" + accessToken).then((res) => {
          if (res.data.code === 200) {
            const { jwt } = res.data.data;
            this.$cookies.set("token", jwt.token, jwt.expire / 1000);
            this.$cookies.set("phone", res.data.data.mobile, jwt.expire / 1000);
            this.$store.dispatch("getCartList");
          }
        });
      }
    },
    // 获取地址栏参数
    getUrlKey: function (name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
      const r = window.location.search.substr(1).match(reg); // 匹配目标参数
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 获取地址栏 code 登录
    codeLogin() {
      const code = this.getUrlKey("code");
      const url = encodeURIComponent(window.location.origin + window.location.pathname);
      if (code) {
        api.get(`/sso/user_info/code?code=${code}&redirectUrl=${url}`).then((res) => {
          if (res.data.code === 200) {
            const { jwt } = res.data.data;
            this.$cookies.set("token", jwt.token, jwt.expire / 1000);
            this.$cookies.set("phone", res.data.data.mobile, jwt.expire / 1000);
            this.$store.dispatch("getCartList");
          }
        });
      }
    },
  },
};
</script>
